import { init, makeFetchTransport } from '@sentry/react';
import { makeMultiplexedTransport } from '@sentry/core';
import { Envelope, EnvelopeItemType, Event } from '@sentry/types';
import { inRange } from 'lodash';

import federatedModules from '../federatedModules';

interface MatchParam {
  /** The envelope to be sent */
  envelope: Envelope;
  /**
   * A function that returns an event from the envelope if one exists. You can optionally pass an array of envelope item
   * types to filter by - only envelopes matching the given types will be returned.
   *
   * @param types Defaults to ['event'] (only error events will be returned)
   */
  getEvent(types?: EnvelopeItemType[]): Event | undefined;
}

export function dsnFromPageName({
  getEvent,
}: MatchParam): { dsn: string; release: string }[] {
  const event = getEvent();
  if (event?.tags?.page) {
    const app = federatedModules.find(
      (fedModule) => fedModule.path === event?.tags?.page,
    );
    if (app?.sentryDsn) {
      // TODO: Can we get release version using module metadata integration?
      return [{ dsn: app?.sentryDsn, release: '' }];
    }
  }
  return [];
}

const is4XXError = (status: number | undefined) =>
  !!status && inRange(status, 400, 500);

export function initSentry(): void {
  init({
    dsn: SENTRY_DSN,
    environment: BUILD_TARGET,
    transport: makeMultiplexedTransport(makeFetchTransport, dsnFromPageName),
    beforeSend: (event, hint) => {
      if (
        hint.originalException &&
        is4XXError((hint.originalException as CustomHttpError).statusCode)
      ) {
        return null;
      }
      return event;
    },
  });
}
